var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.000000, -13.000000)",
    fill: "#DBDBDB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.7587313,25.8998318 C15.9086956,25.74915 16.1517146,25.7483773 16.302448,25.8982864 L16.302448,25.8982864 L19.597048,29.2094227 C19.6401146,29.2526955 19.6716456,29.3052409 19.6908718,29.3631955 C19.7562408,29.5664227 19.645498,29.7843318 19.4432385,29.8500136 L19.4432385,29.8500136 L14.5059527,31.5028773 C14.3675242,31.5476955 14.2160218,31.51215 14.1122004,31.4093773 C14.009148,31.3058318 13.9737718,31.1528318 14.0199146,31.0137409 L14.0199146,31.0137409 L15.6656766,26.0528318 C15.6841337,25.9948773 15.7164337,25.9431045 15.7587313,25.8998318 Z M25.9005468,15.6989045 C26.0528182,15.5544045 26.291223,15.5544045 26.4434944,15.6989045 L26.4434944,15.6989045 L29.7350182,19.0077227 C29.8857516,19.1591773 29.8857516,19.4033591 29.7350182,19.5540409 L29.7350182,19.5540409 L20.9586468,28.3716318 C20.8079135,28.5230864 20.5648944,28.5230864 20.4149301,28.3716318 L20.4149301,28.3716318 L17.1226373,25.0643591 C16.972673,24.9136773 16.972673,24.6687227 17.1226373,24.5180409 L17.1226373,24.5180409 Z M27.8233196,13.7719545 C28.8961411,12.7426818 30.5849696,12.7426818 31.6585601,13.7719545 C32.7144625,14.836 32.7144625,16.5576364 31.6585601,17.6224545 L31.6585601,17.6224545 L31.1094601,18.1765 C30.9594958,18.3271818 30.7157077,18.3271818 30.5657435,18.1765 L30.5657435,18.1765 L27.2749887,14.8692273 C27.1250244,14.7185455 27.1250244,14.4735909 27.2749887,14.3229091 L27.2749887,14.3229091 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.22f351fbe920903490dce03fe6ad28f7.svg";
export { ForwardRef as ReactComponent };